<template>
    <div>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar referencia</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre')"
                                v-model="referenceName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Celular *</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="celular"
                                placeholder="celular"
                                autocomplete="off"
                                v-validate="modelValidations.item_phone"
                                :error="getError('celular')"
                                v-model="referencePhone">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Descripción *</label>
                    <fg-input   tabindex="3"
                                type="text"
                                name="descripción"
                                placeholder="descripción"
                                autocomplete="off"
                                v-validate="modelValidations.item_description"
                                :error="getError('descripción')"
                                v-model="referenceDescription">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar referencia</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="4"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre')"
                                v-model="referenceName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Celular *</label>
                    <fg-input   tabindex="5"
                                type="number"
                                name="celular"
                                placeholder="celular"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('celular')"
                                v-model="referencePhone">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Descripción *</label>
                    <fg-input   tabindex="6"
                                type="text"
                                name="descripción"
                                placeholder="descripción"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('descripción')"
                                v-model="referenceDescription">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">VALORES FLUJO DE CAJA</h4>
        </div>
        <!-- Inventory -->
        <card  class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Gastos Familiares</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>(Año / Mes) Inicio</label>
                    <el-date-picker
                        v-model="form.cashFlowStartMonth"
                        type="month"
                        placeholder="Seleccione mes inicio periodicidad"
                        @change="handleDatePickerClick">
                    </el-date-picker>
                </div>
                <card-dark v-if="form.cashFlowFamilyExpensesMonths" class="form-horizontal">
                    <div class="card-header text-center">
                        <h6 class="card-title">Gastos familiares</h6>   
                    </div>
                    <div class="card-body">
                        <div class="form-group" v-for="(month, index) in form.cashFlowFamilyExpensesMonths" :key="index">
                            <label>{{ month.name }} * </label>
                            <vue-numeric  :max=999999999 :tabindex="1+index" currency="$" autocomplete="off" name="gastos familiares" v-validate="modelValidations.item_value" :error="getError('gastos familiares')" separator="." class="form-control" v-model="month.total"></vue-numeric>
                        </div>
                    </div>
                </card-dark> 
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <p-button @click="saveCashFlow()" type="warning">Siguiente</p-button>
            <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, CardDark, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Table, TableColumn, DatePicker} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            Card,
            CardDark,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            [DatePicker.name]: DatePicker
        },
        data() {
        return {
            agroData: null,
            bankCash: 0,
            balanceFamiliarExpenses: 0,
            cashFlow: null,
            form: {
                cashFlowStartMonth: null,
                cashFlowFamilyExpensesMonths: null,
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            actualExpenses: [],
            currentRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            productName: '',
            productQuantity: '',
            productCostUnity: '',
            productSaleUnity: '',
            productCostTotal: '',
            productMonthlyCost: '',
            referenceName: '',
            referencePhone: '',
            referenceDescription: '',
            modelValidations: {
                average_selection: {
                    required: true
                },
                item_name: {
                    required: false
                },
            },
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                sales: {
                    required: true
                },
                product_name: {
                    required: false
                },
                item_costs: {
                    required: true,
                    min: 1,
                    max: 28
                },
                item_name: {
                    required: true,
                    max: 32
                },
                item_phone: {
                    required: true,
                    max: 12
                },
                item_description: {
                    required: true,
                    max: 32
                }
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.expenses': function (newVal, oldVal) {
                if (!newVal) {
                    this.actualExpenses = [];
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.inventory': function (newVal, oldVal) {
                if (!newVal) {
                    this.products = []
                }
            },
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalInventory != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalInventory ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalInventory() {
                var sum = 0;
                for (let i = 0;i<this.products.length;i++) {
                    sum = sum + this.products[i].productCostTotal; 
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            calculateExcedenteForMonths(cashFlowMonths, agroData) {
                let updatedMonths = JSON.parse(JSON.stringify(cashFlowMonths)); // Copia profunda
                let totalExcedente = 0; // Variable para almacenar el excedente total

                updatedMonths.forEach(month => {
                    // 1️⃣ Sumar los valores de historicalYields (Ingresos históricos)
                    let totalHistorical = month.historicalYields && Array.isArray(month.historicalYields)
                        ? month.historicalYields.reduce((sum, item) => sum + (item.value || 0), 0)
                        : 0;

                    // 2️⃣ Sumar los valores de seasonalSales (Ventas estacionales)
                    let totalSeasonal = month.seasonalSales && Array.isArray(month.seasonalSales)
                        ? month.seasonalSales.reduce((sum, item) => sum + (item.total || 0), 0)
                        : 0;

                    // 3️⃣ Tomar el valor de products
                    let totalProducts = month.products || 0;

                    // 4️⃣ Sumar los valores de agroData (Ingresos adicionales)
                    let operatingUtility = agroData && agroData.microBalance ? agroData.microBalance.operatingUtility || 0 : 0;
                    let spouseValue = agroData && agroData.spouseBalance ? agroData.spouseBalance.spouseValue || 0 : 0;
                    let sumSalaries = agroData && agroData.sumSalaries ? agroData.sumSalaries : 0;
                    let sumJournals = agroData && agroData.sumJournals ? agroData.sumJournals : 0;

                    // 🔹 **Cálculo de ingresos totales**
                    let totalIngresos = totalHistorical + totalSeasonal + totalProducts +
                                        operatingUtility + spouseValue + sumSalaries + sumJournals;

                    // 5️⃣ Sumar los valores de historicalExpenses (Gastos históricos)
                    let totalHistoricalExpenses = month.historicalExpenses && Array.isArray(month.historicalExpenses)
                        ? month.historicalExpenses.reduce((sum, item) => sum + (item.expenseTotal || 0), 0)
                        : 0;

                    // 6️⃣ Sumar los valores de seasonalExpenses (Gastos estacionales)
                    let totalSeasonalExpenses = month.seasonalExpenses && Array.isArray(month.seasonalExpenses)
                        ? month.seasonalExpenses.reduce((sum, item) => sum + (item.expenseTotal || 0), 0)
                        : 0;

                    // 7️⃣ Sumar los valores individuales de gastos adicionales
                    let labourExpenses = month.labourExpenses || 0;
                    let anotherExpenses = month.anotherExpenses || 0;
                    let familiarExpenses = month.familiarExpenses || 0;

                    // 🔹 **Cálculo de gastos totales**
                    let totalGastos = totalHistoricalExpenses + totalSeasonalExpenses + 
                                    labourExpenses + anotherExpenses + familiarExpenses;

                    // 8️⃣ Calcular el excedente neto (Ingresos - Gastos) para el mes
                    month.excedente = totalIngresos - totalGastos;

                    // 9️⃣ Acumular el excedente en la variable totalExcedente
                    totalExcedente += month.excedente;
                });

                console.log("📢 Excedente actualizado con agroData y gastos:", updatedMonths);
                console.log("💰 Excedente total:", totalExcedente);

                return { updatedMonths, totalExcedente };
            },
            // assignFamiliarExpensesToMonths(familiarExpenses, updatedMonths) {
            //     console.log("📢 Asignando gastos familiares a cada mes...");

            //     let totalizedFamiliarExpenses = 0;

            //     // 🔹 1️⃣ Inicializamos familiarExpenses en cada mes
            //     updatedMonths.forEach(month => {
            //         month.familiarExpenses = 0; // Inicializar con 0
            //     });

            //     // 🔹 2️⃣ Iteramos sobre cada gasto familiar
            //     familiarExpenses.forEach(expense => {
            //         let expenseMonth = expense.name;
            //         let expenseTotal = expense.total;

            //         // 🔹 3️⃣ Buscar el mes correspondiente en updatedMonths y sumarlo
            //         let monthEntry = updatedMonths.find(m => m.name === expenseMonth);
            //         if (monthEntry) {
            //             console.log(`💰 Asignando ${expenseTotal} a ${expenseMonth}`);
            //             monthEntry.familiarExpenses += expenseTotal;
            //             totalizedFamiliarExpenses += expenseTotal;
            //         } else {
            //             console.log(`⚠️ No se encontró el mes ${expenseMonth} en los datos.`);
            //         }
            //     });

            //     console.log("✅ Gastos familiares asignados correctamente.");
            //     console.log("📌 Totalizado de gastos familiares:", totalizedFamiliarExpenses);

            //     return { updatedMonths, totalizedFamiliarExpenses };
            // },
            assignFamiliarExpensesToMonths(familiarExpenses, updatedMonths) {
                console.log("📢 Asignando gastos familiares a cada mes...");

                let totalizedFamiliarExpenses = 0;

                // 🔹 1️⃣ Inicializamos familiarExpenses en cada mes
                updatedMonths.forEach(month => {
                    month.familiarExpenses = 0; // Inicializar con 0
                });

                // 🔹 2️⃣ Iteramos sobre cada gasto familiar
                familiarExpenses.forEach(expense => {
                    let [expenseMonthName] = expense.name.split("/"); // Extraer solo el mes
                    let expenseTotal = expense.total;

                    // 🔹 3️⃣ Buscar TODOS los meses que coincidan en nombre, sin importar el año
                    let matchingMonths = updatedMonths.filter(m => m.name.startsWith(expenseMonthName + "/"));

                    if (matchingMonths.length > 0) {
                        matchingMonths.forEach(monthEntry => {
                            console.log(`💰 Asignando ${expenseTotal} a ${monthEntry.name}`);
                            monthEntry.familiarExpenses += expenseTotal;
                            totalizedFamiliarExpenses += expenseTotal;
                        });
                    } else {
                        console.log(`⚠️ No se encontraron meses con el nombre ${expenseMonthName} en los datos.`);
                    }
                });

                console.log("✅ Gastos familiares asignados correctamente.");
                console.log("📌 Totalizado de gastos familiares:", totalizedFamiliarExpenses);

                return { updatedMonths, totalizedFamiliarExpenses };
            },


            handleDatePickerClick(){
                this.generateFamilyExpensesMonths(this.cashFlow.clientTerm);
            },
            generateFamilyExpensesMonths(term) {
                const MAX_TERM = 12; // Máximo de 12 meses adicionales
                const limitedTerm = Math.min(term, MAX_TERM); // Limitar el término al máximo permitido

                // Validar que cashFlowStartMonth sea un objeto Date válido
                if (!this.form.cashFlowStartMonth || !(this.form.cashFlowStartMonth instanceof Date)) {
                    console.error("cashFlowStartMonth debe ser un objeto Date válido.");
                    return;
                }

                // Obtener el mes y el año inicial
                const startMonth = this.form.cashFlowStartMonth.getMonth(); // Mes inicial (0 = enero)
                const startYear = this.form.cashFlowStartMonth.getFullYear(); // Año inicial

                const monthNames = [
                    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                ];

                // Crear los meses desde el mes inicial hasta limitedTerm meses adicionales
                this.form.cashFlowFamilyExpensesMonths = Array.from({ length: limitedTerm }, (_, i) => {
                    const totalMonths = startMonth + i; // Índice del mes total
                    const year = startYear + Math.floor(totalMonths / 12); // Ajustar el año si excede diciembre
                    const monthIndex = totalMonths % 12; // Índice del mes en el rango 0-11

                    return {
                        name: `${monthNames[monthIndex]}/${year.toString().slice(-2)}`, // Ejemplo: Enero/24
                        total: this.balanceFamiliarExpenses, // Inicializa el total vacío
                    };
                });
            },
            validateAgroMicro () {
                if (this.$store.state.isCustomer) {
                    const countStudies = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies.length;
                    if(countStudies > 1){
                        var firstProduct = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                        if(firstProduct.name.toLowerCase() == 'agropecuario'){
                            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)  
                            if(product.name.toLowerCase() == 'microcrédito'){
                                return true
                            }
                            else {
                                return false
                            }
                        }
                        else {
                            return false
                        }
                        
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        this.products.push({
                            referenceName: this.referenceName,
                            referencePhone: this.referencePhone,
                            referenceDescription: this.referenceDescription
                        })
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Producto agregado correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.referenceName = '';
                this.referencePhone = '';
                this.referenceDescription = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.referenceName= this.currentRow.referenceName;
                this.referencePhone= this.currentRow.referencePhone;
                this.referenceDescription= this.currentRow.referenceDescription;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].referenceName = this.referenceName;
                            this.products[index].referencePhone = this.referencePhone;
                            this.products[index].referenceDescription = this.referenceDescription;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.errors.clear();
                            this.showNotificationSuccess('Referencia editada correctamente');
                        }
                })
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productSaleUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCashFlow () {
                if (this.form.cashFlowStartMonth && this.form.cashFlowFamilyExpensesMonths.length > 0) {
                    
                    let { updatedMonths, totalizedFamiliarExpenses } = this.assignFamiliarExpensesToMonths(this.form.cashFlowFamilyExpensesMonths, this.cashFlowData.months);
                    // ✅ Reutilizamos updatedMonths en la segunda función
                    let { updatedMonths: finalUpdatedMonths, totalExcedente } = this.calculateExcedenteForMonths(updatedMonths, this.agroData);

                    const payload = {
                        form: {
                            cashFlowStartMonth: this.form.cashFlowStartMonth,
                            cashFlowFamilyExpensesMonths: this.form.cashFlowFamilyExpensesMonths,
                        },
                        months: finalUpdatedMonths,
                        totalizedFamiliarExpenses: totalizedFamiliarExpenses,
                        bankCash: this.bankCash,
                        totalExcedente: totalExcedente

                    };
                    this.$store.dispatch('setAgrocashFlowFamilyExpensesMonths', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/agro/cash_flow_2step');
                    });
                } else {
                    this.showNotificationError('Gastos familiares no diligenciados');
                }
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowFamilyExpensesMonths && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowFamilyExpensesMonths.cashFlowStartMonth != null) {
                    this.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowFamilyExpensesMonths;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
                this.agroData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData;
                this.cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlow;
                this.balanceFamiliarExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].balance[0].if.expenses.total
                this.bankCash = (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].balance[0].b.assets.cash)+parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].balance[0].b.assets.banks) || 0)
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowFamilyExpensesMonths && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowFamilyExpensesMonths.cashFlowStartMonth != null) {
                    this.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowFamilyExpensesMonths;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
                this.cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlow;
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowFamilyExpensesMonths && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowFamilyExpensesMonths.cashFlowStartMonth != null) {
                    this.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowFamilyExpensesMonths;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
                this.agroData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData;
                this.cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlow;
                this.balanceFamiliarExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].studies[0].balance[0].if.expenses.total
                this.bankCash = (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].studies[0].balance[0].b.assets.cash)+parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].studies[0].balance[0].b.assets.banks) || 0)
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
